import * as React from 'react'
import { Checkbox } from '@fluentui/react-components'
import { InvoiceHeaderItemProps, useItemStyles } from './BaseInvoiceOverview'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import BaseOverviewCountBadge from '../../BaseOverview/BaseOverviewCountBadge'
import InvoiceListItemTurnover from './InvoiceListItemTurnover'

export default function InvoiceHeaderItem(props: InvoiceHeaderItemProps) {
    const itemStyles = useItemStyles()

    if (props.viewportNarrow) {
        return (
            <>
                {props.onAllItemsSelected && (
                    <Checkbox
                        checked={props.isAllItemsSelected?.(props.items)}
                        disabled={!props.isAllItemsSelectable?.(props.items)}
                        onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                    />
                )}
                <BaseOverviewCountBadge {...props} />
                <div className={props.onAllItemsSelected ? itemStyles.listInvoiceItemNarrowBottomRowSelectable : itemStyles.listInvoiceItemNarrowBottomRow}>
                    <div></div>
                    <div></div>
                    {!props.viewportNarrow && <div></div>}
                    {!props.viewportNarrow && <div></div>}
                    <div>
                        <InvoiceListItemTurnover {...props} />
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            {props.onAllItemsSelected && (
                <Checkbox
                    checked={props.isAllItemsSelected?.(props.items)}
                    disabled={!props.isAllItemsSelectable?.(props.items)}
                    onChange={(_, data) => props.onAllItemsSelected(data, props.items)}
                />
            )}
            <BaseOverviewCountBadge {...props} />
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>
                <InvoiceListItemTurnover {...props} />
            </div>
            {!props.viewportMedium && <div></div>}
            {!props.viewportMedium && (
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText
                            key={index}
                            value={{
                                currency: currency.currency,
                                amount: currency.outstandingTotal || '0.00',
                            }}
                            textProps={{
                                size: 300,
                            }}
                            align="right"
                        />
                    ))}
                </div>
            )}
            <div></div>
            <div></div>
        </>
    )
}
